'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-white p-4">
      <div className="text-center max-w-2xl">
        {/* GoGedit Logo */}
        <div className="flex justify-center mb-8">
          <AppLogo className="h-16 w-auto" />
        </div>

        {/* 404 Error */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-blue-600 opacity-20 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-lg text-gray-600 mb-2">
            We couldn't find the page you're looking for.
          </p>
          <p className="text-base text-gray-500">
            Don't worry, let's get you back on track with GoGedit!
          </p>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link
            href="/home-page"
            className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <Icon name="HomeIcon" size={20} />
            Go to Home
          </Link>

          <Link
            href="/home-page#services"
            className="inline-flex items-center justify-center gap-2 bg-white text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200 shadow-md hover:shadow-lg"
          >
            <Icon name="TruckIcon" size={20} />
            View Services
          </Link>

          <Link
            href="/contact-us"
            className="inline-flex items-center justify-center gap-2 bg-white text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200 shadow-md hover:shadow-lg"
          >
            <Icon name="PhoneIcon" size={20} />
            Contact Us
          </Link>
        </div>

        {/* Additional Help */}
        <div className="pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">
            Need help? Here are some popular pages:
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link href="/about-us" className="text-blue-600 hover:text-blue-800 hover:underline">
              About Us
            </Link>
            <span className="text-gray-300">|</span>
            <Link href="/faq" className="text-blue-600 hover:text-blue-800 hover:underline">
              FAQ
            </Link>
            <span className="text-gray-300">|</span>
            <Link href="/blog" className="text-blue-600 hover:text-blue-800 hover:underline">
              Blog
            </Link>
            <span className="text-gray-300">|</span>
            <Link href="/be-a-driver" className="text-blue-600 hover:text-blue-800 hover:underline">
              Be a Driver
            </Link>
            <span className="text-gray-300">|</span>
            <Link href="/be-a-user" className="text-blue-600 hover:text-blue-800 hover:underline">
              Be a User
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}